<template>
  <footer class="footer" >
    <div style="width: 1200px; display: flex;padding-top: 3%;height: 300px; " :style="{ marginLeft: `${margin}px`, marginRight: `${margin}px` }">
      <div style="width: 30%;height: 100%; margin-top: 0px;">
        <img  src="@/assets/images/logo_dibu@2x.png" alt="Logo" style="width: 50%;height: auto;margin-top: 0px;"
          @click="this.$router.push({ path: '/home' })">
        <div style="margin-top: 6%;line-height: 26px; font-size: 14px;width:80%;text-indent: 4ch;">
          数字化教育平台，集成「学-练-考-评」全链闭环。精准诊断知识短板，定制个性路径；加速知识实战转化。以数据科技重塑教育公平，缔造智慧学习新生态。
        </div>
      </div>
      <div style="width: 50%;height: 100%; font-size: 14px;">
        <div style="display: flex;padding-top: 3%;line-height: 20px;">
          <div style="width: 20%;">
            <p style="color: white;font-weight: bold; " >快速导航</p>
            <p @click="this.$router.push({ path: '/me/myIndex' })" class="text">个人中心</p>
            <p @click="this.$router.push({ path: '/me' })" class="text">我的资料</p>
            <p>价格套餐</p>
            <p>企业服务</p>
          </div>
          <div style="width: 20%;">
            <p style="color: white;font-weight: bold;">了解我们</p>
            <p>关于我们</p>
            <p>用户协议</p>
            <p>隐私政策</p>
            <p>使用帮助</p>
          </div>
          <div style="width: 60%;">
            <p style="color: white;font-weight: bold;">联系我们</p>
            <p>联系电话: 400-666-888</p>
            <p>售后服务：zhipei@dkart.cn</p>
            <p>工作时间：zhipei@dkart.cn</p>
            <p>总部地址：北京市朝阳区管庄路东方华瑞科技园A座 702</p>
          </div>
        </div>
      </div>
      <div style="width: 20%;height: 100%;padding: 0px; ">
          <div style=" margin-left: 110px; width: 40%;text-align: center;margin-top: 6%;">
            <img  src="@/assets/images/bg-dibu_erweima@2x.png" alt="erweima" style="width: 100%;height: 100%;">
          <p style="font-size: 12px; margin-top: 5%;color: white;">扫码访问移动版</p>
          </div>
      </div>
    </div>
    <div style="text-align: center;margin-top: 2%;">
      <p> Copyright © 2025&nbsp; Zhipei.xyz &nbsp;智培云&nbsp; All Riglts Reserved &nbsp;&nbsp;ICP备案：京ICP备14009336号-3 &nbsp;当前版本:1.2.1</p>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      margin: 0,
    };
  },

  methods: {
    calculateMargin() {
      const windowWidth = window.innerWidth;
      const contentWidth = 1200;
      this.margin = (windowWidth - contentWidth) / 2;
    },
  },
  mounted() {
    this.calculateMargin();
    window.addEventListener('resize', this.calculateMargin);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateMargin);
  },
}
</script>

<style scoped>
p {
  
  font-size: 14px;
}
.text{
  cursor: pointer;
}
.text:hover {
  color: #2E8FD4;
}

.footer {
  color: #8C96A5;
  background-color: black;
  padding: 10px 20px;
  z-index: 1;
  width: 100%;
  margin-top: auto
}
</style>